<script setup lang="ts">
import type { KirbyBlock } from "#nuxt-kirby";

defineProps<{
  block?: KirbyBlock<"text">;
}>();
</script>

<template>
  <div class="block-container" v-html="block?.content.text" />
</template>
